import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { CommonWrapper } from '../SharedStyles'
import ValuePropositionWrapper from './components/ValuePropositionWrapper'

const BOTShopForTires = ({
  placeholders: {
    leftContent = []
  } = {},
  ...props
}) =>
  <Wrapper>
    <RightSection>
      <ShopTiresWrapper>
        <ValuePropositionWrapper />
      </ShopTiresWrapper>
    </RightSection>
    <LeftSection>
      { leftContent }
    </LeftSection>
  </Wrapper>

BOTShopForTires.propTypes = {
  '@type': PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    leftContent: PropTypes.arrayOf(),
    rightContent: PropTypes.arrayOf()
  })
}

BOTShopForTires.type = 'BOTShopForTires'
BOTShopForTires.placeholders = ['leftContent', 'rightContent']

export default BOTShopForTires

const Wrapper = styled(CommonWrapper)`
  ${Mixin.clearFix()}
`

const LeftSection = styled.div`
  margin-top: 30px;
  line-height: 1.5;
  ${Media.desktop`
    position: relative;
    float: left;
    width: calc(100% - 500px);
    min-height: 200px;
    padding-right: 20px;
  `}
`

const ShopTiresWrapper = styled.div`
  ${Media.desktop`
    position: relative;
    top: -65px;
    right: -45px;
    height: 528px;
  `}
  ${Mixin.responsive('margin', '30px 0 0', '30px -15px 0')}
`

const RightSection = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 250px;
    right: 70px;
    width: 460px;
  `}
`
